import styled from '@emotion/styled';
import React from 'react';
import { i18n } from 'src/common';
import { colors } from 'src/theme';
import { ArrowRightIcon, Button, Flex, Text } from '..';

export interface CrossSellAdditionalCardProps {
  voucherActive?: boolean;
  voucherDescription?: string;
  loading?: boolean;
  /** Rendered between the copy and the CTA — the captcha challenge slot. */
  beforeCta?: React.ReactNode;
  ctaDisabled?: boolean;
  onCtaClick: () => void;
}

const CrossSellCardStyle = styled.div({
  marginTop: 32,
  padding: '24px 16px',
  background: colors.background8,
  borderRadius: 8,
  width: '100%',
  maxWidth: 600,
  textAlign: 'center',
});

/**
 * Cross-sell block shown on the supplementary thank-you page.
 * Only a message and a CTA — offers/packages are intentionally not shown here;
 * the CTA leads into the standard additional-insurance funnel.
 */
export const CrossSellAdditionalCard = ({ voucherActive, voucherDescription, loading, beforeCta, ctaDisabled, onCtaClick }: CrossSellAdditionalCardProps) => (
  <CrossSellCardStyle>
    <Flex vertical align="center" gap={16}>
      <Text type="large" bold>
        {i18n.t('components.cards.crossSellAdditionalCard.title')}
      </Text>
      <Text type="medium" color={colors.text2}>
        {i18n.t('components.cards.crossSellAdditionalCard.description')}
      </Text>
      {voucherActive && (
        <Text type="small" color={colors.text2}>
          {voucherDescription
            ? i18n.t('components.cards.crossSellAdditionalCard.voucherHint', { description: voucherDescription })
            : i18n.t('components.cards.crossSellAdditionalCard.voucherHintGeneric')}
        </Text>
      )}
      {beforeCta}
      <Button btnType="primary" size="large" onClick={onCtaClick} loading={loading} disabled={loading || ctaDisabled} text={i18n.t('components.cards.crossSellAdditionalCard.ctaButton')}>
        <ArrowRightIcon color={colors.white} />
      </Button>
    </Flex>
  </CrossSellCardStyle>
);
